import React from 'react';

const Units = ({ onChange, productId, units, removeItem }) => (
    <div className="unit-selector">
        <button onClick={() => units === 1 ? removeItem({ productId }) : onChange('-', productId)}>{units == 1 ? <i className="fa fa-trash"/> : '-'}</button>
        <div>{units}</div>
        <button onClick={() => onChange('+', productId)}>+</button>
    </div>
);

export default Units;